/**
 * WinterMute fragment model.
 *
 * A Fragment is one narrative unit: a claim, rumour, or memory. Fragments carry
 * their rhetorical mechanism (`tactic`) as data — this is what makes the drift
 * map legible rather than decorative — and their lineage (`parents`), which is
 * what lets the network render a rhizome rather than a flat archive.
 */
export const TACTICS = [
    'nostalgia',
    'fear',
    'identity',
    'authority',
    'doubt',
];
/** Runtime guards for data that crosses a trust boundary (network, LLM output). */
export function isTactic(x) {
    return typeof x === 'string' && TACTICS.includes(x);
}
export const LANGS = ['ro', 'ru', 'en', 'nl'];
export function isLang(x) {
    return typeof x === 'string' && LANGS.includes(x);
}
export const MUTATION_OPS = [
    'amplify',
    'soften',
    'contradict',
    'attribute',
    'personalize',
    'erode',
];
export function isMutationOp(x) {
    return typeof x === 'string' && MUTATION_OPS.includes(x);
}
export function emptyTacticDwell() {
    return { nostalgia: 0, fear: 0, identity: 0, authority: 0, doubt: 0 };
}
/**
 * Map vitality to a coarse state. Thresholds are intentionally simple; the
 * renderer maps these to detail/sharpness, not opacity.
 */
export function fragmentState(f) {
    if (f.vitality >= 0.55)
        return 'alive';
    if (f.vitality >= 0.2)
        return 'eroding';
    return 'slogan';
}
//# sourceMappingURL=model.js.map